<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>FAQs</h1>
                        <span>Tem dúvidas sobre a Trainka? Veja as respostas para as principais dúvidas em nossa lista de perguntas frequentes.</span>
                        <!-- <a href="https://demo.trinka.ai/" target="_blank">Try it Now</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="verticalTabSection">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="questionSections">
                    <ul class="nav nav-tabs">
                        <li (click)="gotoTop()"><a class="active" href="#TrinkaTabs" data-toggle="tab">Trinka</a></li>
                        <li (click)="gotoTop()"><a href="#AccountTabs" data-toggle="tab">Conta de Usuário</a></li>
                        <li (click)="gotoTop()"><a href="#AccountPaymentsTabs" data-toggle="tab">Pagamentos</a></li>
                        <li (click)="gotoTop()"><a href="#PlansTabs" data-toggle="tab">Planos</a></li>
                        <li (click)="gotoTop()"><a href="#GeneralTabs" data-toggle="tab">Geral</a></li>
                        <li (click)="gotoTop()"><a href="#SecurityTab" data-toggle="tab">Segurança</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-8">
                <div class="answersSections">
                    <div class="tab-content">
                        <div class="tab-pane active" id="TrinkaTabs">
                            <div class="accordion" id="TrinkaTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionOneContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionOneContent">O que é Trinka?</a>
                                    </div>

                                    <div id="TrinkaQuestionOneContent" class="collapse show"
                                        aria-labelledby="TrinkaQuestionOne" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>A Trinka é um assistente de redação com tecnologia de IA que verifica seu texto quanto a erros de gramática, ortografia, estilo e consistência e fornece feedback corretivo e acionável. Ele também vai além da correção e sugere os melhores aprimoramentos de tom e estilo. Além disso, Trinka verifica sua redação em busca de linguagem tendenciosa e sensível, dá dicas sobre redação concisa, reduz expressões redundantes, escreve frases e termos específicos de uma disciplina e usa recursos de redação acadêmica como palavras secretas, contrações e inglês formal. Além disso, também verifica se o seu manuscrito está pronto para publicação.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionTwoContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionTwoContent">Em que a Trinka difere de outras ferramentas online para verificar sua escrita?</a>
                                    </div>

                                    <div id="TrinkaQuestionTwoContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionTwo" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Embora vários verificadores gramaticais estejam disponíveis para o inglês geral, poucos se concentram na redação do inglês acadêmico, terminologia, convenção científica e questões relacionadas à preparação para publicação. A Trinka foi criada especificamente para escritores acadêmicos inexperientes em inglês escrito. Em nossa comparação recente, descobrimos que a Trinka é o assistente de redação que melhor se adapta à redação acadêmica, pois é mais precisa e cobre uma ampla gama de questões de redação. <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']" >Clique aqui</a> para ler o white paper. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionThreeContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionThreeContent">Como a Trinka verifica minha escrita?</a>
                                    </div>

                                    <div id="TrinkaQuestionThreeContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionThree" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>A Trinka é atualizada com milhões de manuscritos de diferentes áreas temáticas e usa uma combinação de algoritmos de Processamento de Linguagem Natural (PNL) e regras gramaticais que são regularmente atualizadas e rigorosamente testadas.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionFourContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionFourContent">Quão preciso é o verificador gramatical da Trinka?</a>
                                    </div>

                                    <div id="TrinkaQuestionFourContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionFour" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>A Trinka foi projetada especificamente para conteúdo acadêmico. Portanto, ele tem o melhor desempenho em conteúdo acadêmico / técnico. Nossas avaliações sobre conjuntos de dados relevantes mostram que geralmente alcançamos> 90% de precisão e> 80% de recall. Este é o equilíbrio mais importante que mantemos e, claro, é fundamental para alcançar os melhores resultados em conteúdo acadêmico / técnico. Os resultados podem variar de acordo com o assunto. Trinka fica melhor com cada feedback que você dá.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionFiveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionFiveContent">O verificador gramatical Trinka é gratuito?</a>
                                    </div>

                                    <div id="TrinkaQuestionFiveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionFive" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. O plano Básico da Trinka é totalmente gratuito. No entanto, ele vem com algumas limitações e restrições. Você pode verificar nossa seção de <a [routerLink]="['/pricing']">preços</a> para mais detalhes.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionSixContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionSixContent">Como a Trinka pode ajudar na redação técnica?</a>
                                    </div>

                                    <div id="TrinkaQuestionSixContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionSix" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>A Trinka é uma ferramenta de verificação gramatical com IA que verifica mais de 3000 erros gramaticais complexos, aprimoramentos de tom e estilo, formatos de acordo com os guias de estilo APA e AMA e funciona em todas as áreas de assunto.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionSevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionSevenContent">A Trinka substitui a revisão?</a>
                                    </div>

                                    <div id="TrinkaQuestionSevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionSeven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Isso depende da qualidade da escrita original. Se você não é um nativo do idioma inglês e comete vários erros complexos que estão relacionados à construção lógica em inglês, um revisor especialista seria benéfico. A Trinka pode corrigir milhares de erros gramaticais e problemas de escrita complexos. No entanto, a IA tem suas limitações. Ele não pode decifrar o significado pretendido se a construção não for lógica. Por outro lado, se você tiver conhecimento suficiente da língua inglesa para formar construções logicamente corretas com segurança, a Trinka cuidará das questões restantes, como tom, escolha de palavras, construções gramaticais, ortografia e muito mais.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionEightContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionEightContent">A Trinka é seguro para escrever teses? Posso usá-lo para verificar a gramática na minha tese? </a>
                                    </div>

                                    <div id="TrinkaQuestionEightContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim, a Trinka funciona bem com todas as formas de redação acadêmica / técnica. Definitivamente, você pode usar para suas teses, artigos de pesquisa, relatórios, ensaios e muito mais.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="TrinkaQuestionNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionNineContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionNineContent">Can Trinka check a PDF for grammar and or spelling issues? </a>
                                    </div>
    
                                    <div id="TrinkaQuestionNineContent" class="collapse" aria-labelledby="TrinkaQuestionNine"
                                        data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Currently, Trinka supports MS Word files (doc/docx). We will add support for pdf and LaTeX files soon. </p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionTen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionTenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionTenContent">A Trinka pode verificar se há problemas gramaticais e / ou ortográficos em um PDF?</a>
                                    </div>

                                    <div id="TrinkaQuestionTenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionTen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Atualmente, a Trinka só suporta arquivos MS Word (doc / docx). Adicionaremos suporte para arquivos PDF e LaTeX em breve.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestioneleven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelevenContent">O que você deve fazer se uma palavra correta for marcada como incorreta?</a>
                                    </div>

                                    <div id="TrinkaQuestionelevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestioneleven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>O modelo de IA da Trinka aprende com milhões de conteúdo publicado. No entanto, há momentos em que encontra novas palavras. Se destacar uma palavra como incorreta quando você tiver certeza de que está digitada corretamente, basta adicioná-la ao seu dicionário Trinka pessoal (procure o botão 'Adicionar ao dicionário' nos cartões de sugestão). Depois de adicionar uma palavra ao seu dicionário, a Trinka não irá destacá-la como um erro.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwelve">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwelveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwelveContent">Meu texto aparecerá como plagiado se eu usar a Trinka?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwelveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwelve" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>O Trinka ajuda a aprimorar sua redação eliminando problemas de linguagem. Ocorre plágio quando você usa textos publicados sem citar a fonte corretamente. Embora o uso do Trinka não vá criar novos plágios, recomendamos submeter seu documento à nossa Verificação de Plágio para ter certeza de que você não plagiou algum conteúdo por acidente.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelThirteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelThirteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelThirteenContent">A Trinka formata o artigo no formato APA?</a>
                                    </div>

                                    <div id="TrinkaQuestionelThirteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelThirteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim, você pode usar a opção de guia de estilo APA embutida na Trinka para aplicar todas as preferências linguísticas / de escrita APA. Observe que a Trinka atualmente não aplica preferências de APA, como margens de página, numeração, estilos de títulos, etc.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelFourteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelFourteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelFourteenContent">A Trinka oferece suporte a outros idiomas além do inglês?</a>
                                    </div>

                                    <div id="TrinkaQuestionelFourteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelFourteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Não. A Trinka é projetada para funcionar com conteúdo em inglês.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelFiveteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelFiveteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelFiveteenContent">Posso acessar a Trinka em vários dispositivos?</a>
                                    </div>

                                    <div id="TrinkaQuestionelFiveteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelFiveteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim! Você pode acessar o site da Trinka em seu computador (PC, Mac, Chromebooks), tablets (iPad, Android, Windows), dispositivos móveis (iOS, Android, outros sistemas operacionais). Você pode acessar a Trinka em qualquer dispositivo que suporte um navegador da web moderno.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelSixteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelSixteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelSixteenContent">Posso usar a API Trinka?</a>
                                    </div>

                                    <div id="TrinkaQuestionelSixteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelSixteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. A poderosa API da Trinka permite integrá-lo em qualquer aplicativo. A API simples de usar oferece alta confiabilidade e escalabilidade. Visite nossa seção <a [routerLink]="['/enterprise']">Enterprise</a> para mais detalhes.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelSeventeen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelSeventeenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelSeventeenContent">Posso entrar na minha conta Trinka de vários dispositivos simultaneamente?</a>
                                    </div>

                                    <div id="TrinkaQuestionelSeventeenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelSeventeen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. No entanto, observe que você não pode trabalhar no mesmo arquivo em mais de um local. Você pode editar um arquivo dentro da Trinka de apenas um dispositivo / navegador por vez.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelEighteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelEighteenContent">What is the maximum word count Trinka can check?</a>
                                    </div>
    
                                    <div id="TrinkaQuestionelEighteenContent" class="collapse" aria-labelledby="TrinkaQuestionelEighteen"
                                        data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka can check for language and grammar for up to 150 words on our demo tool, and this limit gets exceeded once you register for free.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelNineteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelNineteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelNineteenContent">Com quais versões do MS Word o plug-in Trinka Word é compatível?</a>
                                    </div>

                                    <div id="TrinkaQuestionelNineteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelNineteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>O plug-in Trinka Word é compatível com Microsoft Word 2010 e superior no Windows. <a [routerLink]="['/wordplugin']">Clique aqui</a> para mais detalhes.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelEighteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelEighteenContent">A Trinka funciona no Chrome?</a>
                                    </div>

                                    <div id="TrinkaQuestionelEighteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelEighteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. Você pode instalar o plug-in do navegador Chrome da Trinka <a [routerLink]="['/browser-plugin']">aqui</a>.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwoenty">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwoentyContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwoentyContent">A Trinka funciona no Firefox?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwoentyContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwoenty" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. Você pode instalar o plug-in do navegador Firefox da Trinka <a [routerLink]="['/browser-plugin']">aqui</a>.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyOneContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyOneContent">A Trinka funciona no Edge?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyOneContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyOne" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. Você pode instalar o plug-in do navegador Edge da Trinka <a [routerLink]="['/browser-plugin']">aqui</a>.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyTwoContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyTwoContent">Por que a extensão da Trinka não funciona em alguns sites?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyTwoContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyTwo" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Os sites que permitem a criação de conteúdo podem ter arquiteturas e designs variados. Às vezes, um site pode interferir na forma como a extensão Trinka lê sua escrita. Compartilhe seu feedback em sites onde não está funcionando corretamente, e nós encontraremos a maneira de fazê-lo funcionar. Você sempre pode nos escrever em <a href="mailto:support@trinka.ai">support@trinka.ai</a> para qualquer ajuda.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyThreeContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyThreeContent">A Trinka funciona no Facebook?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyThreeContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyThree" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Com certeza, basta instalar nosso plug-in de navegador para o seu navegador favorito e deixar a Trinka fazer a mágica. Você pode encontrar o plug-in do navegador <a [routerLink]="['/browser-plugin']">aqui</a>.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyFoureContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyFoureContent">A Trinka funciona no LinkedIn?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyFoureContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyFoure" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Absolutamente. Basta instalar o plug-in do nosso navegador para o seu navegador favorito e deixar a Trinka fazer a mágica. Você pode encontrar o plug-in do navegador <a [routerLink]="['/browser-plugin']">aqui</a>.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyFiveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyFiveContent">A Trinka funciona no Reddit?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyFiveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyFive" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Absolutamente. Basta instalar o plug-in do nosso navegador para o seu navegador favorito e deixar a Trinka fazer a mágica. Você pode encontrar o plug-in do navegador <a [routerLink]="['/browser-plugin']">aqui</a>.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentySix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentySixContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentySixContent">A Trinka funciona para o LaTeX?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentySixContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentySix" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Atualmente, a Trinka não suporta arquivos LaTeX. Adicionaremos suporte para este formato em breve.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentySeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentySevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentySevenContent">A Trinka mostrou duas ou mais correções em minha frase, mas ao corrigir uma, a (s) outra (s) foram embora. Por quê?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentySevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentySeven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Existe a possibilidade de que a primeira correção pode ter tornado a segunda correção (ou outras correções) desnecessária. Observe que, depois que o usuário aceita uma das sugestões e faz uma alteração na frase, a Trinka verifica novamente se há erros na frase revisada.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionEightContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionEightContent">O que o Redator faz e em que difere dos Aprimoramentos?</a>
                                    </div>

                                    <div id="GenernalQuestionEightContent" class="collapse"
                                        aria-labelledby="GenernalQuestionEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>O Consultor de redação é destinado a escritores que desejam empregar um tom acadêmico em seus textos. Esses recursos são exclusivos da redação em inglês acadêmico e das convenções científicas. Ele fornece feedback sobre palavras de proteção ou reforço, modificadores fracos, frases de voz passiva que podem ser alteradas para a voz ativa e a qualidade geral das frases. Os aprimoramentos cobrem apenas os aspectos da escrita que são gramaticalmente sólidos, mas têm espaço para aprimoramento e polimento adicionais, por exemplo, reduzindo a contagem de palavras empregando palavras concisas, neutralizando linguagem tendenciosa ou sensível ou usando palavras mais simples no lugar de palavras mais longas e complexas.</p>
                                        </div>
                                    </div>
                                </div>




                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyEightContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyEightContent">A Trinka pode ser usado offline?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyEightContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Não, a Trinka precisa de uma conexão ativa com a internet para verificar se há erros no seu texto. No entanto, você pode experimentar nosso recurso de <a href="https://www.trinka.ai/pt/features/auto-file-edit">edição automática de arquivo</a>, que permite fazer upload de seu arquivo MS Word e baixar uma versão alterada controlada para revisão off-line.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyNineContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyNineContent">Que tipo de arquivo pode ser verificado usando a Trinka?</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyNineContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyNine" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Atualmente, oferecemos suporte a arquivos MS Word (doc / docx), arquivos txt e arquivos rtf. Adicionaremos suporte para arquivos PDF e LaTeX em breve.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="AccountPaymentsTabs">
                            <div class="accordion" id="APTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="APQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#APQuestionOneContent" aria-expanded="true"
                                            aria-controls="APQuestionOneContent">Por que meu cartão de crédito foi recusado?</a>
                                    </div>

                                    <div id="APQuestionOneContent" class="collapse show" aria-labelledby="APQuestionOne"
                                        data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>Esse problema pode ser desencadeado por vários motivos.</p>
                                            <ol>
                                                <li>Seu cartão de crédito não suporta transações internacionais</li>
                                                <li>Você inseriu detalhes incorretos</li>
                                                <li>Você esgotou seu limite de crédito.
                                                    </li>
                                            </ol>
                                            <p>Se o problema persistir, entre em contato com o seu banco. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="APQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#APQuestionTwoContent" aria-expanded="true"
                                            aria-controls="APQuestionTwoContent">Quais modos de pagamento você aceita?</a>
                                    </div>

                                    <div id="APQuestionTwoContent" class="collapse" aria-labelledby="APQuestionTwo"
                                        data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>A Trinka atualmente aceita cartões de crédito para pagamentos. Todos os cartões de crédito que oferecem suporte a transações internacionais devem funcionar. Se você estiver enfrentando problemas com sua forma de pagamento, pode escrever para nós em <a href="mailto:support@trinka.ai">support@trinka.ai</a></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionThreeContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionThreeContent">Onde insiro meu código de desconto / cupom?</a>
                                    </div>

                                    <div id="GenernalQuestionThreeContent" class="collapse"
                                        aria-labelledby="GenernalQuestionThree" data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>Atualmente, você receberá um link de pagamento exclusivo para sua compra com desconto. Em breve, você poderá inserir seu código de desconto durante o pagamento.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="AccountTabs">
                            <div class="accordion" id="AccountQuestions">
                                <div class="card">
                                    <div class="card-header" id="AccountQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionOneContent" aria-expanded="true"
                                            aria-controls="AccountQuestionOneContent">O plug-in do navegador Trinka não detecta minha conta Premium.</a>
                                    </div>

                                    <div id="AccountQuestionOneContent" class="collapse show"
                                        aria-labelledby="AccountQuestionOne" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>Depois de instalar o plug-in do navegador, você precisará fazer login em sua conta Trinka por meio dele. Se você estiver enfrentando dificuldades para fazer login, escreva para <a href="mailto:support@trinka.ai">support@trinka.ai</a></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="AccountQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionTwoContent" aria-expanded="true"
                                            aria-controls="AccountQuestionTwoContent">Como faço para obter um reembolso?</a>
                                    </div>

                                    <div id="AccountQuestionTwoContent" class="collapse"
                                        aria-labelledby="AccountQuestionTwo" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>De acordo com nossa política, não emitimos reembolsos para assinaturas adquiridas. Você pode nos escrever em <a href="mailto:support@trinka.ai">support@trinka.ai</a> para cancelar as renovações automáticas de sua assinatura.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="AccountQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionThreeContent" aria-expanded="true"
                                            aria-controls="AccountQuestionThreeContent">I am unable to receive
                                            verification email</a>
                                    </div>

                                    <div id="AccountQuestionThreeContent" class="collapse"
                                        aria-labelledby="AccountQuestionThree" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>Please check the spam folder for the verification mail. If you still are
                                                unable to find the verification mail, then please contact our support on
                                                <a href="mailto:support@trinka.ai">support@trinka.ai</a> and we will be
                                                glad to assist you.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="AccountQuestionFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionFoureContent" aria-expanded="true"
                                            aria-controls="AccountQuestionFoureContent">Como posso deletar minha conta?</a>
                                    </div>

                                    <div id="AccountQuestionFoureContent" class="collapse"
                                        aria-labelledby="AccountQuestionFoure" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>Escreva para nós em <a href="mailto:support@trinka.ai">support@trinka.ai</a></p>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="tab-pane" id="PlansTabs">
                            <div class="accordion" id="PlansTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="PlanQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionOneContent" aria-expanded="true"
                                            aria-controls="PlanQuestionOneContent">A assinatura é renovada automaticamente?</a>
                                    </div>

                                    <div id="PlanQuestionOneContent" class="collapse show"
                                        aria-labelledby="PlanQuestionOne" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p class="mb-2">Sim, a assinatura é renovada automaticamente. Se você quiser cancelar a renovação automática, siga os passos abaixo:</p>
                                            <ul>
                                                <li><a href="https://cloud.trinka.ai/signin?_rg=GB" class="hyperLink" target="_blank">Faça login </a> na sua conta do Trinka.</li>
                                                <li>Clique no botão “Account settings” ("Configurações da conta") no canto superior direito do painel do Trinka.</li>
                                                <li>Clique no link “Cancel subscription renewal” ("Cancelar a renovação da assinatura" mostrado na parte da assinatura.</li>
                                            </ul>
                                        
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="PlanQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionTwoContent" aria-expanded="true"
                                            aria-controls="PlanQuestionTwoContent">Can I get a student discount?</a>
                                    </div>

                                    <div id="PlanQuestionTwoContent" class="collapse" aria-labelledby="PlanQuestionTwo"
                                        data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>Yes, student discounts are available. Write to us at <a
                                                    href="mailto:sales@trinka.ai">sales@trinka.ai</a> to know more and
                                                get your student discount.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="PlanQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionThreeContent" aria-expanded="true"
                                            aria-controls="PlanQuestionThreeContent">Posso atualizar minha assinatura?</a>
                                    </div>

                                    <div id="PlanQuestionThreeContent" class="collapse"
                                        aria-labelledby="PlanQuestionThree" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>Escreva para nós em <a href="mailto:support@trinka.ai">support@trinka.ai</a>. Em breve, você poderá fazer isso nas configurações de sua conta.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="PlanQuestionFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionFourContent" aria-expanded="true"
                                            aria-controls="PlanQuestionFourContent">Você oferece desconto para compras a granel / em grupo?</a>
                                    </div>

                                    <div id="PlanQuestionFourContent" class="collapse"
                                        aria-labelledby="PlanQuestionFour" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. Licenças de equipe atraem descontos dependendo do tamanho da equipe. Você pode nos escrever em <a href="mailto:sales@trinka.ai">sales@trinka.ai</a> para um orçamento personalizado para sua equipe.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="tab-pane" id="GeneralTabs">
                            <div class="accordion" id="GeneralTabsQuestion">
                                <!-- <div class="card">
                                    <div class="card-header" id="GeneralQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionOneContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionOneContent">How to enable grammar checker in
                                            MS Word?</a>
                                    </div>

                                    <div id="GeneralQuestionOneContent" class="collapse show"
                                        aria-labelledby="GeneralQuestionOne" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Once you have installed Trinka MS Word Add-in, open any document in MS Word, look out for Trinka in the toolbar, and click
                                                to open it. Log in using your Trinka credentials if prompted. Once you
                                                are logged in, you should see the Trinka toolbar, and it should also
                                                start displaying the suggestions.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="GeneralQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionTwoContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionTwoContent">Preciso baixar algum software de verificação gramatical?</a>
                                    </div>

                                    <div id="GeneralQuestionTwoContent" class="collapse show"
                                        aria-labelledby="GeneralQuestionTwo" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Não, você não precisa baixar nenhum software para usar a Trinka. Simplesmente faça o login em um navegador da web e comece a usar o Trinka. No entanto, você precisará instalar nosso plug-in do MS Word (em breve) se quiser usar o verificador gramatical Trinka no Microsoft Word.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GeneralQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionThreeContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionThreeContent">O que é verificador ortográfico contextual?</a>
                                    </div>

                                    <div id="GeneralQuestionThreeContent" class="collapse"
                                        aria-labelledby="GeneralQuestionThree" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Um verificador ortográfico contextual identifica uma palavra digitada corretamente usada no contexto errado. Por exemplo, a palavra pretendida "site" pode se tornar a palavra "visão". Um corretor ortográfico comum não consegue identificar esse tipo de erro.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionFoureContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionFoureContent">Como a escrita técnica é diferente da escrita geral?</a>
                                    </div>

                                    <div id="GenernalQuestionFoureContent" class="collapse"
                                        aria-labelledby="GenernalQuestionFoure" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>A redação geral e a redação técnica seguem as mesmas regras de gramática, ortografia e pontuação. No entanto, a redação técnica tem tom e estilo profissionais e inclui o relato de fatos, detalhes, estatísticas, etc. A redação técnica não contém opiniões, ao contrário da redação geral.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionFiveContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionFiveContent">Como a escrita técnica é diferente da escrita acadêmica?</a>
                                    </div>

                                    <div id="GenernalQuestionFiveContent" class="collapse"
                                        aria-labelledby="GenernalQuestionFive" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>A redação técnica se concentra em fornecer informações detalhadas e claras sobre o serviço ou produto. A escrita acadêmica se concentra em provar uma teoria ou um ponto de vista e enfatiza um assunto específico.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionSixContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionSixContent">A Trinka é compatível com os sistemas Apple Mac?</a>
                                    </div>

                                    <div id="GenernalQuestionSixContent" class="collapse"
                                        aria-labelledby="GenernalQuestionSix" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. Você pode acessar a Trinka Cloud (o site da Trinka) em todos os sistemas operacionais. Em breve estaremos lançando o suplemento Trinka Microsoft Word para computadores Windows e Mac.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionSevenContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionSevenContent">Você tem um programa de afiliados?</a>
                                    </div>

                                    <div id="GenernalQuestionSevenContent" class="collapse"
                                        aria-labelledby="GenernalQuestionSeven" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Sim. O programa de afiliados da Trinka permite que você ganhe enquanto indica clientes para o nosso site. É fácil e gratuito participar. Você pode encontrar mais detalhes <a [routerLink]="['/affiliates']">aqui</a>.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="GenernalQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionEightContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionEightContent">What does Writing Adviser do
                                            and how is it different from Enhancements?</a>
                                    </div>

                                    <div id="GenernalQuestionEightContent" class="collapse"
                                        aria-labelledby="GenernalQuestionEight" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Writing Adviser is designed for writers who wish to employ an academic
                                                tone in their texts. These features are unique to academic English
                                                writing and scientific convention. It provides feedback on hedge or
                                                booster words, weak modifiers, passive voice sentences that can be
                                                changed to the active voice, and the overall quality of sentences.
                                                Enhancements cover only those aspects of writing which are grammatically
                                                sound but have scope for further improvement and polishing, e.g.,
                                                reducing the word count employing concise words, neutralizing biased or
                                                sensitive language, or using simpler words in place of longer, complex
                                                ones.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionNineContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionNineContent">Com quem posso entrar em contato para solucionar quaisquer problemas que possa enfrentar?</a>
                                    </div>

                                    <div id="GenernalQuestionNineContent" class="collapse"
                                        aria-labelledby="GenernalQuestionNine" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Escreva para nós em <a href="mailto:support@trinka.ai">support@trinka.ai</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div class="tab-pane" id="SecurityTab">
                            <div class="accordion" id="SecurityTabQuestion">
                                <div class="card">
                                    <div class="card-header" id="SecurityQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#SecurityQuestionOneContent" aria-expanded="true"
                                            aria-controls="SecurityQuestionOneContent">A Trinka pode acessar minhas senhas?</a>
                                    </div>

                                    <div id="SecurityQuestionOneContent" class="collapse show"
                                        aria-labelledby="SecurityQuestionOne" data-parent="#SecurityTabQuestion">
                                        <div class="card-body">
                                            <p>Não, a Trinka não tem acesso a informações confidenciais, como senhas ou informações de cartão de crédito.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="SecurityQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#SecurityQuestionOneContent" aria-expanded="true"
                                            aria-controls="SecurityQuestionOneContent">Meus dados são seguros e confidenciais?</a>
                                    </div>

                                    <div id="SecurityQuestionOneContent" class="collapse"
                                        aria-labelledby="SecurityQuestionOne" data-parent="#SecurityTabQuestion">
                                        <div class="card-body">
                                            <p>Levamos a privacidade e a segurança de dados muito a sério. Usamos criptografia de chave pública / privada de 256 bits para transferência de dados e arquivos e possuímos certificados SSL de alta segurança - um certificado de segurança aceito mundialmente e a mais alta medida para prevenir ameaças. Não compartilhamos seus dados privados com terceiros. Se você tiver alguma dúvida ou precisar de mais informações, entre em contato conosco pelo e-mail <a href="mailto:support@trinka.ai">support@trinka.ai</a>.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="FAQFooterSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="FAQfooterText">
                    <h2>O que você está esperando?</h2>
                    <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Registre Grátis</a>
                </div>
            </div>
        </div>
    </div>
</div>

<script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is Trinka?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Trinka is an AI-powered writing assistant that checks your text for grammar, spelling, style, and consistency errors and gives corrective and actionable feedback. It also goes beyond correction and suggests the finest tone and style enhancements. In addition, Trinka checks your writing for biased and sensitive language, gives you tips on concise writing, reduces redundant expressions, writes discipline-specific phrases and terms, and uses academic writing features like hedge words, contractions, and formal English. Moreover, it also checks if your manuscript is publication-ready. "
          }
        },
        {
          "@type": "Question",
          "name": "How is Trinka different from other online tools for checking your writing?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "While several grammar checkers are available for general English, very few focus on academic English writing, terminology, scientific convention, and publication readiness-related issues. Trinka is specifically built for academic writers who are inexperienced in written English. In our recent comparison, we found that Trinka is the writing assistant that suits academic writing the best as it is most accurate and covers a wide range of writing issues. Get more details Trinka here."
          }
        },
        {
          "@type": "Question",
          "name": "How does Trinka check my writing?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Trinka is trained with millions of manuscripts from different subject areas and uses a combination of Natural Language Processing (NLP) algorithms and grammar rules that are regularly updated and stringently tested."
          }
        },
        {
          "@type": "Question",
          "name": "How accurate is Trinka's grammar checker?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Trinka is specifically designed for academic content. Hence, it performs the best on academic and technical content. Our assessments on relevant data sets show that we generally achieve >90% precision and >80% recall. This is the most important balance that we maintain and is of course critical to achieving the best results on academic/technical content. The results may vary based on the subject. Trinka gets better with every feedback that you give."
          }
        },
        {
          "@type": "Question",
          "name": "How to enable grammar checker in MS Word?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Once you have installed Trinka MS Word Add-in, open any document in MS Word, look out for Trinka in the toolbar, and click to open it. Log in using your Trinka credentials if prompted. Once you are logged in, you should see the Trinka toolbar, and it should also start displaying the suggestions."
          }
        },
        {
          "@type": "Question",
          "name": "Do I need to download any grammar checker software?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No, You do not need to download any software to use Trinka. Simply log in from a web browser and start using Trinka. However, you will need to install our MS Word Add-in (coming soon) if you want to use Trinka grammar checker in Microsoft Word."
          }
        },
        {
          "@type": "Question",
          "name": "Is Trinka grammar checker free to use?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Trinka's Basic plan is completely free to use. However, it does come with a few limitations and restrictions. You can check out our Pricing section for more details."
          }
        },
        {
          "@type": "Question",
          "name": "What is contextual spelling checker?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A contextual spelling checker identifies a correctly spelled word used in the wrong context. For example, the intended word \"\"site\"\" might become the word \"sight.\" An ordinary spell checker cannot identify such an error.  "
          }
        },
        {
          "@type": "Question",
          "name": "How can Trinka help in technical writing?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Trinka is an AI-powered grammar checker tool that checks for 3000+ complex grammar errors, tone and style enhancements, formats according to APA and AMA style guides, and works on all subject areas. "
          }
        },
        {
          "@type": "Question",
          "name": "How is technical writing different from general writing?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "General writing and technical writing both follow the same rules of grammar, spelling, and punctuation. However, technical writing has a professional tone and style, and includes reporting facts, details, statistics, etc. Technical writing does not contain opinions, while general writing does."
          }
        },
        {
          "@type": "Question",
          "name": "How is technical writing different from academic writing?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Technical writing focuses on providing detailed and clear information about the service or product. Academic writing focuses on proving a theory or a viewpoint and emphasizes one specific subject."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka replace proofreading?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "This depends on the quality of original writing. If you are not a native English speaker and make several complex mistakes that are to do with logical construction in English, then an expert proofreader would be beneficial. Trinka can correct thousands of grammatical errors and complex writing issues. However, AI has its limitations. It cannot decipher your intended meaning if the construction is not logical. In contrast, if you have sufficient knowledge of the English language to confidently form logically correct constructs, then Trinka will take care of the remaining issues such as tone, word choice, grammatical constructions, spellings, and much more."
          }
        },
        {
          "@type": "Question",
          "name": "Is Trinka safe for thesis writing? Can I use it to check the grammar in my thesis? ",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Trinka works well with all forms of academic/technical writing. You can definitely use for your theses, research papers, reports, essays, and more."
          }
        },
        {
          "@type": "Question",
          "name": "Can Trinka check a PDF for grammar and/or spelling issues? ",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Currently, Trinka only supports MS Word files (doc/docx). We will add support for pdf and LaTeX files soon."
          }
        },
        {
          "@type": "Question",
          "name": "Can Trinka access my passwords?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No, Trinka has no access to sensitive information such as passwords or credit card information."
          }
        },
        {
          "@type": "Question",
          "name": "What should you do if a correct word is marked as misspelt?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Trinka's AI model learns from millions of published content. However, there are times when it encounters new words. If it highlights a word as misspelled when you are sure that it is rightly spelled, just add it to your personal Trinka dictionary (look for the 'Add to dictionary' button on the suggestion cards). Once you add a word to your dictionary, Trinka will not highlight it as an error."
          }
        },
        {
          "@type": "Question",
          "name": "Will my text show up as plagiarized if I use Trinka?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Trinka helps improve your writing to eliminate language issues. Plagiarism is when you use published text without citing the source correctly. While using Trinka will not introduce plagiarism, you must ensure that you avoid plagiarism in your writing by phrasing in your own style and citing the source appropriately."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka format the article in APA format?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, you can use the APA style guide option built into Trinka to apply all APA linguistic/writing preferences. Do note that Trinka currently does not apply APA preferences such as page margins, numbering, headings styles, etc."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka support languages other than English?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No. Trinka is designed to work with English content."
          }
        },
        {
          "@type": "Question",
          "name": "Is Trinka Compatible with Apple Mac systems?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. You can access Trinka Cloud (the Trinka web site) on all operating systems. We will soon be releasing the Trinka Microsoft Word add-in for both Windows and Mac computers."
          }
        },
        {
          "@type": "Question",
          "name": "Can I access Trinka on multiple devices?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes! You can access the Trinka web site on your computer (PC, Mac, Chromebooks), tablets (iPad, Android, Windows), mobile devices (iOS, Android, other operating systems). You can access Trinka on any device that supports a modern web browser."
          }
        },
        {
          "@type": "Question",
          "name": "Can I use Trinka API?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Trinka's powerful API lets you integrate it on any application. The simple-to-use API offers high reliability and scalability. Visit our Enterprise for more details."
          }
        },
        {
          "@type": "Question",
          "name": "Can I log into my Trinka account from multiple devices simultaneously?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. However, do note that you cannot work on the same file from more than one location. You can edit a file within Trinka from only one device/browser at a time."
          }
        },
        {
          "@type": "Question",
          "name": "The Trinka browser plug-in doesn't detect my Premium account.",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Once you install the browser add-on/extension, you will need to log in to your Trinka account through it. If you are facing difficulties logging in, please write to us at support@trinka.ai"
          }
        },
        {
          "@type": "Question",
          "name": "What versions of MS Word is the Trinka Word Plug-In compatible with?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Trinka Word Plug-In is compatible on Microsoft Word 2010 and above on Windows. Click here for more details."
          }
        },
        {
          "@type": "Question",
          "name": "Can I upgrade my subscription?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Please write to us at support@trinka.ai. You will soon be able to do so from your account settings."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka work in Chrome?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. You can install Trinka's Safari browser plug-in from here."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka work in Firefox?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. You can install Trinka's Firefox browser plug-in from here."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka work in Safari?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. You can install Trinka's Chrome browser plug-in from here."
          }
        },
        {
          "@type": "Question",
          "name": "Where do I input my discount/coupon code?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Currently, you will receive a unique payment link for your discounted purchase. Soon, you will be able to enter your discount code during payment."
          }
        },
        {
          "@type": "Question",
          "name": "Do you offer a discount for bulk/group purchases?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Team licenses attract discounts depending on the size of the team. You can write to us at sales@trinka.ai for a customized quote for your team."
          }
        },
        {
          "@type": "Question",
          "name": "Do you have an affiliate program?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Trinka's affiliate program allows you to earn while you refer customers to our website. It is easy and free to join. You can find more details here."
          }
        },
        {
          "@type": "Question",
          "name": "Why doesn't Trinka's extension work on some websites?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Websites that allow creating content can have varying architectures and designs. Sometimes, a website may interfere with how the Trinka extension reads your writing. Do share your feedback on sites where it is not working correctly, and we will find a way to make it work. You can always write to us at support@trinka.ai for any help."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka work on Facebook?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Absolutely. Just install our browser plug-in for your favourite browser and let Trinka do it's magic. You can find the browser plug-in here."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka work on LinkedIn?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Absolutely. Just install our browser plug-in for your favourite browser and let Trinka do it's magic. You can find the browser plug-in here."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka work on Reddit?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Absolutely. Just install our browser plug-in for your favourite browser and let Trinka do it's magic. You can find the browser plug-in here."
          }
        },
        {
          "@type": "Question",
          "name": "Does Trinka work for LaTeX?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Currently, Trinka does not support LaTeX files. We will add support for this format soon."
          }
        },
        {
          "@type": "Question",
          "name": "Trinka showed two or more corrections in my sentence but on correcting one, the other(s) went away. Why?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "There is a possibility that the first correction may have rendered the second correction (or other corrections) unnecessary. Do note that after the user accepts one of the suggestions and makes a change to the sentence, Trinka rechecks the revised sentence for errors."
          }
        },
        {
          "@type": "Question",
          "name": "Is my data secure and confidential?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We take privacy and data security very seriously. We use 256-bit Public/Private key encryption for data and file transfers and hold high-assurance SSL Certificates - a worldwide accepted security certificate and the highest measure to prevent threats. We do not share your private data with any third party. Should you have any concern or need more information, please contact us at support@trinka.ai."
          }
        },
        {
          "@type": "Question",
          "name": "What does Writing Adviser do and how is it different from Enhancements?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Writing Adviser is designed for writers who wish to employ an academic tone in their texts. These features are unique to academic English writing and scientific convention. It provides feedback on hedge or booster words, weak modifiers, passive voice sentences that can be changed to the active voice, and the overall quality of sentences. Enhancements cover only those aspects of writing which are grammatically sound but have scope for further improvement and polishing, e.g., reducing the word count employing concise words, neutralizing biased or sensitive language, or using simpler words in place of longer, complex ones."
          }
        },
        {
          "@type": "Question",
          "name": "Can Trinka be used offline?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No, Trinka needs an active internet connection to check your text for errors. However, you can try our Auto File Edit feature which allows you to upload your MS Word file and download a tracked changed version for offline review."
          }
        },
        {
          "@type": "Question",
          "name": "What type of files can be checked using Trinka?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Currently, we support MS Word files (doc/docx), txt files, and rtf files. We will add support for pdf and LaTeX files soon."
          }
        },
        {
          "@type": "Question",
          "name": "Whom can I contact to troubleshoot any issues I might face?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Please write to us at support@trinka.ai"
          }
        }
      ]
    }
    </script>